var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApartment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1400_4153",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 19,
    height: 19
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1400_4153)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.57227 16.2897V5.60221H5.73893V2.43555H13.2598V8.76888H16.4264V16.2897H10.4889V13.123H8.50977V16.2897H2.57227ZM3.75977 15.1022H5.73893V13.123H3.75977V15.1022ZM3.75977 11.9355H5.73893V9.95638H3.75977V11.9355ZM3.75977 8.76888H5.73893V6.78971H3.75977V8.76888ZM6.92643 11.9355H8.9056V9.95638H6.92643V11.9355ZM6.92643 8.76888H8.9056V6.78971H6.92643V8.76888ZM6.92643 5.60221H8.9056V3.62305H6.92643V5.60221ZM10.0931 11.9355H12.0723V9.95638H10.0931V11.9355ZM10.0931 8.76888H12.0723V6.78971H10.0931V8.76888ZM10.0931 5.60221H12.0723V3.62305H10.0931V5.60221ZM13.2598 15.1022H15.2389V13.123H13.2598V15.1022ZM13.2598 11.9355H15.2389V9.95638H13.2598V11.9355Z",
    fill: "#001E40",
    fillOpacity: 0.6
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApartment);
export default __webpack_public_path__ + "static/media/apartment.fd4afaf6996d505a9d0ff2e0a4ef5614.svg";
export { ForwardRef as ReactComponent };